import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useState } from 'react';
import clientService from '../../../../services/ClientService';
import ReportTable from './ReportTable';

const Report = ({ row, onCancelChanges }) => {
  const [customerWithEmployeeReport, setCustomerWithEmployeeReport] = useState([]);

  useEffect(() => {
    const fetchCustomerTotalHoursOfEmployee = async () => {
      try {
        const response = await clientService.getCustomerTotalHoursOfEmployee(row.Id);
        const customerEmployeeRecords = response?.data?.data;

        setCustomerWithEmployeeReport(customerEmployeeRecords);
      } catch (error) {
        // eslint-disable-next-line no-console, no-undef
        console.error('error is:', error);
      }
    };
    fetchCustomerTotalHoursOfEmployee();
  }, [row.Id]);

  return (
    <div style={{ height: '700px' }}>
      <DialogTitle id="form-dialog-title">Project Time Activity of {row?.DisplayName}</DialogTitle>
      <DialogContent>
        <ReportTable rows={customerWithEmployeeReport} />
      </DialogContent>
      <DialogActions style={{ padding: '0 23px 16px 0' }}>
        <Button onClick={onCancelChanges} color="secondary" variant="outlined" style={{ marginTop: '1rem' }}>
          Cancel
        </Button>
      </DialogActions>
    </div>
  );
};

export default Report;

Report.propTypes = {
  onCancelChanges: PropTypes.func,
  setCustomerTabIndex: PropTypes.func,
  row: PropTypes.any
};
